/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      21 February 2024
 */
import React from 'react';

interface Props {
  component: React.ReactNode;
}

const Hero = ({ component }: Props) => {
  return (
    <div className='bg-dark-950'>
      <div className='relative isolate'>
        <figure className='group relative transition-all duration-300 cursor-pointer'>
          <div className='absolute inset-0 bg-dark-950 opacity-70 transition-opacity duration-700'></div>
          <video
            poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/hero-poster_y4knb1'
            className='w-full h-full bg-video hidden md:block'
            preload='auto'
            playsInline
            autoPlay
            muted
            loop
            data-object-fit='cover'
          >
            <source
              src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/hero_jzkcut'
              type='video/mp4'
            />
            <source
              src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/hero_hjmcv0'
              type='video/webm'
            />
          </video>
          <video
            poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/hero-h-poster_lqcu25'
            className='w-full h-full bg-video block md:hidden'
            preload='auto'
            playsInline
            autoPlay
            muted
            loop
            data-object-fit='cover'
          >
            <source
              src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/hero-h_n0lzcd'
              type='video/mp4'
            />
            <source
              src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/hero-h_fbwxif'
              type='video/webm'
            />
          </video>
          <figcaption className='max-w-[1920px] absolute text-white top-4 left-1/2 transform w-full lg:top-1/4 -translate-x-1/2 px-6 py-2 md:mt-8 text-center overflow-wrap'>
            {component}
          </figcaption>
        </figure>
      </div>
    </div>
  );
};
export default Hero;
